import trans from '@common/i18n/v1/trans'

import SVGIcon from '@common/components/SVGIcon/SVGIcon'

import styles from './Footer.scss'

export default function Footer (): HTMLElement {
  return (
    <section id="contact" className={ styles.footer }>
      <div className="container">
        <div className={ styles.information }>
          <div className={ styles.contactRow }>
            <div className={ styles.icon } data-type="facebook" />

            <a
              href="https://www.facebook.com/mosolyteremto"
              rel="noopener noreferrer"
              target="_blank"
            >
              { trans('Footer.facebook') }
            </a>
          </div>

          <div className={ styles.contactRow }>
            <SVGIcon type="mail" />
            <a href={ `mailto: ${ trans('Footer.email') }` }>{ trans('Footer.email') }</a>
          </div>

          <div className={ styles.contactRow }>
            <SVGIcon type="location" />
            <div>{ trans('Footer.address') }</div>
          </div>

          { /*
          <div className={ styles.contactRow }>
            <SVGIcon type="phone" />
            <div>{ trans('Footer.telephone') }</div>
          </div>
          */ }
        </div>
      </div>

      <div className={ styles.dateRow }>
        <div className={ styles.dateRowLeft }>{ `@${ (new Date()).getFullYear() }` }</div>
        <div className={ styles.dateRowRight }>Mosolyteremtő.hu</div>
      </div>
    </section>
  )
}
